import { GameDayModel } from '../../models/gameday-model';
import {
  getViewOrder,
  ViewOrder
} from '../../gameday/mappers/gameDay-orders.transfomations';
import { amountFormat } from '../../gameday/gameday.constants';

// Order mappers
export function getAllOrdersOrder(order: GameDayModel.Order): ViewOrder {
  const viewOrder: ViewOrder = getViewOrder(order);
  const coupon: number = order.maturity.coupon;

  return { ...viewOrder, coupon };
}

// Value formatters
export function getFormattedMaturityCoupon({ value: couponCell }): string {
  return !!couponCell || couponCell === 0 ? `${couponCell.toFixed(3)}%` : '';
}

export function getFormattedTotal({ value: amount }): string {
  return amountFormat.format(amount);
}
